function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.06 22.16H5.94c-1.95 0-3.44-.71-4.2-1.99-.75-1.28-.65-2.93.3-4.63L8.1 4.63c1-1.8 2.38-2.79 3.9-2.79s2.9.99 3.9 2.79l6.06 10.91c.95 1.71 1.06 3.35.3 4.63-.76 1.28-2.25 1.99-4.2 1.99zM12 3.34c-.94 0-1.86.72-2.59 2.02L3.36 16.27c-.68 1.22-.79 2.34-.32 3.15.47.8 1.51 1.25 2.91 1.25h12.12c1.4 0 2.43-.44 2.91-1.25.47-.81.36-1.92-.32-3.15L14.59 5.36c-.73-1.3-1.65-2.02-2.59-2.02z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.44 20.75c-.15 0-.3-.04-.43-.14L12 14.3l-9.01 6.31a.74.74 0 01-1.04-.18.74.74 0 01.18-1.04l9.44-6.61c.26-.18.6-.18.86 0l9.44 6.61c.34.24.42.71.18 1.04-.14.21-.37.32-.61.32z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 14.14c-.41 0-.75-.34-.75-.75V3c0-.41.34-.75.75-.75s.75.34.75.75v10.39c0 .41-.34.75-.75.75z"
})));